import PropTypes from 'prop-types';
import React from 'react';

import 'commons-vehicle/Vehicle/components/TileTag/TileTag.scss';

const TileTag = ({ shouldRender, icon, background, color, text, dealerClass }) => {
    if (!shouldRender) {
        return null;
    }

    const style = {
        background,
        color,
    };

    return (
        <div className={`tile-tag picto-showroom is-bold ${dealerClass}`} style={style}>
            {icon && <icon className={icon} />}
            <span>{text}</span>
        </div>
    );
};

TileTag.defaultProps = {
    icon: null,
    background: '#fff',
    color: '#000',
};

TileTag.propTypes = {
    shouldRender: PropTypes.bool.isRequired,
    icon: PropTypes.string,
    background: PropTypes.string,
    color: PropTypes.string,
    text: PropTypes.string.isRequired,
    dealerClass: PropTypes.string,
};

TileTag.displayName = 'TileTag';

export default TileTag;
